import { render, staticRenderFns } from "./AnswerBox.vue?vue&type=template&id=e6be5bd2&"
import script from "./AnswerBox.vue?vue&type=script&lang=js&"
export * from "./AnswerBox.vue?vue&type=script&lang=js&"
import style0 from "./AnswerBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports